export function getDeviceId() {
  const { deviceId } = uni.getSystemInfoSync();
  return deviceId;
}
